import { WORKFLOW_TRIGGER_EVENTS } from '../constants';
import { TriggerNodeDataTypename } from '../types';

/**
 * Given an event that triggers a workflow, this util function returns the `__typename`
 * string associated with the corresponding start node data type in GraphQL
 */
export const getTriggerNodeDataTypeNameFromEvent = <EventType extends WORKFLOW_TRIGGER_EVENTS>(
  event: EventType,
): TriggerNodeDataTypename<EventType> => `${event}Trigger`;
